import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { Store, select } from '@ngrx/store';
import { CheckListFormComponent } from '@rpe/registro-personas-empresas-lib';
import { State } from '../../../vista-usuario/vista-usuario.state';
import { GrupoEspecieFormInput } from '../../entity-grupos-especie/grupo-especie.model';
import { ViveroGrupoEspecie } from '../entity-viveros-grupo-especie.model';
import { Subscription, combineLatest } from 'rxjs';
import { ViveroFormInput } from '../models/entity-viveros-grupo-especie.models';
import { DireccionesGeograficasFormComponent } from '../../../ubicaciones/direcciones-geograficas/direcciones-geograficas-form/direcciones-geograficas-form.component';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { selectAllGruposEspecie } from '../../entity-grupos-especie/grupos-especie.selectors';
import { selectAllEspecies } from '../../entity-especies/especies.selectors';
import { Especie } from '../../entity-especies/especies.model';
import { GrupoEspecie } from '../../entity-grupos-especie/grupos-especie.model';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { DatosContactoFormComponent } from '../../../contactos/datos-contacto/datos-contacto-form/datos-contacto-form.component';
import {
  DatosContacto,
  createEmptyDatosContacto
} from '../../../contactos/datos-contacto/datos-contacto.model';
import { selectCurrentEmpresa } from '../../../empresas/entity-mis-empresas/entity-current-empresa.selectors';
import { DireccionGeografica } from '../../../ubicaciones/direcciones-geograficas/direcciones-geografica.model';

@Component({
  selector: 'rpe-viveros-form',
  templateUrl: './viveros-form.component.html',
  styleUrls: ['./viveros-form.component.scss']
})
export class ViverosFormComponent implements OnInit, OnDestroy {
  @ViewChild(DatosContactoFormComponent, { static: true })
  datosContactoForm: DatosContactoFormComponent;
  contactoValid: boolean = false;
  datosContacto: DatosContacto;
  datosContactoFormInput: DatosContacto = null;
  datosContactoStatus: string;

  @ViewChild(DireccionesGeograficasFormComponent, { static: true })
  direccionGeograficaForm: DireccionesGeograficasFormComponent;

  @ViewChild(CheckListFormComponent, { static: true })
  checkListForm: CheckListFormComponent;

  primeraVez: boolean = true;

  viveroFormInput: ViveroFormInput;

  @Input() set formInput(auxFormInput: ViveroFormInput) {
    if (auxFormInput.vivero) {
      this.id.setValue(auxFormInput.vivero.id);
      this.viveroFormInput = auxFormInput;
    }

    if (this.primeraVez) {
      if (auxFormInput.vivero?.nombre) {
        this.nombre.setValue(auxFormInput.vivero.nombre);
      }

      if (auxFormInput.vivero) {
        if (auxFormInput.vivero.correos_electronico?.length) {
          this.contacto.setValue({
            correos_electronico: auxFormInput.vivero.correos_electronico?.length
              ? [...auxFormInput.vivero?.correos_electronico]
              : []
          });
          this.datosContactoFormInput = {
            ...this.datosContactoFormInput,
            correos_electronico: auxFormInput.vivero.correos_electronico?.length
              ? [...auxFormInput.vivero?.correos_electronico]
              : []
          };
        } else {
          this.datosContactoFormInput = {
            ...this.datosContactoFormInput,
            correos_electronico: []
          };
          this.contacto.setValue(null);
        }

        if (auxFormInput.vivero.telefonos?.length) {
          this.telefonos.setValue({
            telefonos: auxFormInput.vivero.telefonos?.length
              ? [...auxFormInput.vivero?.telefonos]
              : []
          });
          this.datosContactoFormInput = {
            ...this.datosContactoFormInput,
            telefonos: auxFormInput.vivero.telefonos?.length
              ? [...auxFormInput.vivero?.telefonos]
              : []
          };
        } else {
          this.telefonos.setValue(null);
          this.datosContactoFormInput = {
            ...this.datosContactoFormInput,
            telefonos: []
          };
        }

        if (auxFormInput.vivero?.direccion_geografica) {
          this.direccionGeograficaInput =
            auxFormInput?.vivero.direccion_geografica;
        } else {
          this.initDireccionGeografica();
        }
      } else {
        this.initContacto();
        this.initDireccionGeografica();
      }

      this.emitForm(this.form.value);
    }

    if (auxFormInput?.vivero?.grupos_especies_id?.length > 0 && this.primeraVez) {
      this.selectedGruposEspecie = this.gruposEspecies.filter((gp) =>
        auxFormInput.vivero.grupos_especies_id.includes(gp.id)
      );
    }

    this.primeraVez = false;
  }

  @Output() onFormChange: EventEmitter<ViveroGrupoEspecie> =
    new EventEmitter<ViveroGrupoEspecie>();
  @Output() onStatusFormChange = new EventEmitter<string>();

  contacto: FormControl = new FormControl(null, [Validators.required]);
  direccion: FormControl = new FormControl(null, [Validators.required]);
  gruposEspecie: FormControl = new FormControl([]);
  nombre: FormControl = new FormControl('', [Validators.required]);
  telefonos: FormControl = new FormControl(null, [Validators.required]);
  entidadProductiva: FormControl = new FormControl(null, []);
  id: FormControl = new FormControl(null, []);

  form: FormGroup = new FormGroup({
    id: this.id,
    nombre: this.nombre,
    correos_electronico: this.contacto,
    direccion_geografica: this.direccion,
    grupos_especies_id: this.gruposEspecie,
    telefonos: this.telefonos,
    entidad_productiva_id: this.entidadProductiva
  });

  gruposEspecieForm: FormGroup;

  subscriptions: Subscription[] = [];

  formStatus: string = 'INVALID';

  direccionGeograficaValid: boolean = false;

  direccionGeograficaInput: DireccionGeografica;

  grupoEspecieForm: GrupoEspecieFormInput = null;

  viverosGrupoEspecie: ViveroGrupoEspecie[] = [];

  especies: Especie[] = [];
  gruposEspecies: GrupoEspecie[] = [];

  selectedGruposEspecie: GrupoEspecie[] = [];

  constructor(private store: Store<State>, private fb: FormBuilder) { }

  ngOnInit(): void {
    const storeSubsription = combineLatest([
      this.store.pipe(select(selectAllGruposEspecie)),
      this.store.pipe(select(selectAllEspecies)),
      this.store.pipe(select(selectCurrentEmpresa))
    ]).subscribe(([grupoEspecie, especies, currentEmpresa]) => {
      this.gruposEspecies = grupoEspecie;

      if (this.viveroFormInput?.vivero?.grupos_especies_id?.length > 0) {
        this.selectedGruposEspecie = this.gruposEspecies.filter((gp) =>
          this.viveroFormInput.vivero.grupos_especies_id.includes(gp.id)
        );
      }

      this.entidadProductiva.setValue(currentEmpresa.id);
    });

    const formChange = this.form.valueChanges.subscribe((x) => {
      this.emitForm({
        ...x,
        grupos_especies_id: [...this.selectedGruposEspecie.map((ge) => ge.id)]
      });
    });

    const formStatusChange = this.form.statusChanges.subscribe((x) => this.emitFormStatus(x));

    this.subscriptions.push(formChange, formStatusChange, storeSubsription);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  initContacto(): void {
    this.datosContacto = null;
    this.datosContactoFormInput = createEmptyDatosContacto();
  }

  initDireccionGeografica(): void {
    this.direccionGeograficaInput = null;
  }

  datosContactoChange(dc: DatosContacto) {
    this.datosContacto = dc;
    this.form.patchValue({
      correos_electronico: dc.correos_electronico.map((ce) => {
        return {
          ...ce,
          tipo_correo_id: 1
        };
      }),
      telefonos: dc.telefonos
    });
  }

  emitForm(form: any): void {
    this.onFormChange.emit(form);
  }

  emitFormStatus(isValid: string): void {
    if (
      this.direccionGeograficaValid &&
      this.contactoValid &&
      isValid === 'VALID' &&
      (this.selectedGruposEspecie.length > 0)
    ) {
      this.onStatusFormChange.emit('VALID');
    } else {
      this.onStatusFormChange.emit('INVALID');
    }
  }

  onGruposEspeciesChange(ge: MatCheckboxChange, grupoEspecie: GrupoEspecie) {
    if (ge.checked) {
      this.selectedGruposEspecie.push(grupoEspecie);
    } else {
      this.selectedGruposEspecie = this.selectedGruposEspecie.filter((x) => x.id != grupoEspecie.id);
    }

    this.emitForm({
      ...this.form.value,
      grupos_especies_id: this.selectedGruposEspecie.map((ge) => ge.id)
    });
    this.emitFormStatus(this.form.status);
  }

  isChecked(grupoEspecie: GrupoEspecie): boolean {
    return this.selectedGruposEspecie.find((gp) => gp.id === grupoEspecie.id) ? true : false;
  }

  datosContactoStatusChange(s: any) {
    this.datosContactoStatus = s;
    this.contactoValid = s === 'VALID';
  }

  formStatusChanges(status: string) {
    this.formStatus = status;
  }

  direccionGeograficaChange(dg: DireccionGeografica) {
    this.form.patchValue({
      direccion_geografica: dg
    });
  }

  direccionGeograficaStatusChange(s: string) {
    this.direccionGeograficaValid = s === 'VALID';
  }

  onShowErrors(): void {
    this.form.markAllAsTouched();
    this.datosContactoForm?.checkErrors();
    this.direccionGeograficaForm?.checkErrors();
  }
}
